import {AppPlatformType} from '@toolify/server/src/models/mongoose/SessionModel/enum/AppPlatformType'
import {LocaleType} from '@toolify/server/src/services/UserSettingsService/strategies/LocaleUserSettingStrategy/enum/LocaleType'
import {resolveLocaleTypeFromLanguageTag} from '@toolify/server/src/services/UserSettingsService/strategies/LocaleUserSettingStrategy/functions/resolveLocaleTypeFromLanguageTag'
import {resolveLocaleType} from '@toolify/server/src/services/UserSettingsService/strategies/LocaleUserSettingStrategy/functions/resolveLocaleType'

function isSupportedLocale(value: unknown): value is string {
  return typeof value === 'string' && Object.values(LocaleType).includes(value as LocaleType)
}

/** The URL prefix is the language. No prefix means English on the web, and the device language in the desktop and mobile apps. */
export function resolveGuestLocaleType(input: {
  routeLocale?: unknown
  appPlatformType: AppPlatformType
}): LocaleType {
  if(isSupportedLocale(input.routeLocale)) {
    return resolveLocaleType(input.routeLocale)
  }
  if(input.appPlatformType !== AppPlatformType.Web) {
    const languageTag = typeof navigator === 'undefined' ? undefined : navigator.language
    return resolveLocaleTypeFromLanguageTag(languageTag)
  }
  return LocaleType.English
}
